import PropTypes from 'prop-types';

import { ChildrenSchema, USER_ROLES, useHasAnyAllowedRole } from 'packages/utils';

const ComponentBlocker = ({ children, allowedRoles = null, divId = null }) => {
  const hasAccess = useHasAnyAllowedRole(allowedRoles, divId);

  return hasAccess ? children : null;
};

ComponentBlocker.propTypes = {
  children: ChildrenSchema,
  allowedRoles: PropTypes.arrayOf(PropTypes.oneOf(Object.values(USER_ROLES))),
  divId: PropTypes.string,
};

export default ComponentBlocker;
